function ugcSpotlightBoot() {
  document.querySelectorAll('.ugc-spotlight').forEach(function (root) {
    if (root.dataset.ugcSpotlightInit) return;
    root.dataset.ugcSpotlightInit = 'true';
    initSpotlight(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ugcSpotlightBoot);
} else {
  ugcSpotlightBoot();
}

document.addEventListener('shopify:section:load', function (event) {
  var root = event.target.querySelector('.ugc-spotlight');
  if (root) {
    root.dataset.ugcSpotlightInit = 'true';
    initSpotlight(root);
  }
});

function initSpotlight(root) {
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-spotlight-slide]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-spotlight-dot]'));
  var prevBtn = root.querySelector('[data-spotlight-prev]');
  var nextBtn = root.querySelector('[data-spotlight-next]');
  var autoplay = root.getAttribute('data-autoplay') === 'true';
  var videoAutoplay = root.getAttribute('data-video-autoplay') === 'true';
  var interval = parseInt(root.getAttribute('data-autoplay-interval'), 10) || 6000;
  var current = 0;
  var slideTimer = null;
  var scheduledAt = null;
  var scheduledDuration = interval;
  var remaining = interval;
  // Named pause reasons, tracked independently, so hover-pause and video-pause
  // can never stomp on each other's state. The timer only ever runs when this
  // set is empty.
  var pauseReasons = {};

  function isPausedNow() {
    for (var key in pauseReasons) {
      if (pauseReasons[key]) return true;
    }
    return false;
  }

  function updatePausedClass() {
    root.classList.toggle('is-paused', isPausedNow());
  }

  function startTimer(duration) {
    clearTimeout(slideTimer);
    if (!autoplay || slides.length <= 1 || isPausedNow()) return;
    scheduledAt = Date.now();
    scheduledDuration = duration;
    slideTimer = setTimeout(function () {
      goTo(current + 1);
    }, duration);
  }

  function pauseFor(reason) {
    if (!autoplay || slides.length <= 1) return;
    var wasPaused = isPausedNow();
    pauseReasons[reason] = true;
    if (!wasPaused) {
      clearTimeout(slideTimer);
      if (scheduledAt !== null) {
        remaining = Math.max(0, scheduledDuration - (Date.now() - scheduledAt));
      }
    }
    updatePausedClass();
  }

  function resumeFrom(reason) {
    if (!autoplay || slides.length <= 1) return;
    delete pauseReasons[reason];
    updatePausedClass();
    if (!isPausedNow()) {
      startTimer(remaining);
    }
  }

  function buildEmbedSrc(iframe, muted) {
    var base = iframe.getAttribute('data-embed-src');
    var kind = iframe.getAttribute('data-media-kind');
    var sep = base.indexOf('?') === -1 ? '?' : '&';
    var params = 'autoplay=1';
    if (muted) {
      // YouTube and Vimeo use different parameter names for the same thing
      params += kind === 'vimeo' ? '&muted=1' : '&mute=1';
    }
    return base + sep + params;
  }

  function pauseSlideMedia(slide) {
    var video = slide.querySelector('video');
    if (video) video.pause();
    slide.setAttribute('data-playing', 'false');
    var iframe = slide.querySelector('iframe[data-embed-src]');
    if (iframe) iframe.src = '';
  }

  function playSlideMedia(slide) {
    var video = slide.querySelector('video');
    if (video) {
      // programmatic (non-gesture) autoplay must stay muted or browsers will block it
      video.muted = true;
      video.play().catch(function () {});
      slide.setAttribute('data-playing', 'true');
    }
    var iframe = slide.querySelector('iframe[data-embed-src]');
    if (iframe && !iframe.getAttribute('src')) {
      iframe.src = buildEmbedSrc(iframe, true);
    }
  }

  function restartDotFill(dot) {
    var fill = dot.querySelector('[data-spotlight-dot-fill]');
    if (!fill) return;
    fill.style.animation = 'none';
    // force reflow so the animation restarts cleanly next time it's re-applied
    void fill.offsetWidth;
    fill.style.animation = '';
  }

  function updateDots(index) {
    dots.forEach(function (dot, i) {
      dot.classList.remove('is-active', 'is-animating');
      if (i === index) {
        dot.classList.add('is-active');
        if (autoplay && slides.length > 1) {
          dot.style.setProperty('--ugc-dot-duration', interval + 'ms');
          restartDotFill(dot);
          dot.classList.add('is-animating');
        }
      }
    });
  }

  function goTo(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;

    slides.forEach(function (slide, i) {
      if (i === index) {
        slide.classList.add('is-active');
        pauseSlideMedia(slide);
        if (videoAutoplay) playSlideMedia(slide);
      } else {
        slide.classList.remove('is-active');
        pauseSlideMedia(slide);
      }
    });

    current = index;
    // switching slides always clears any "a video was playing" pause —
    // that pause belonged to the slide we're leaving, not this one
    delete pauseReasons.video;
    updateDots(index);
    // every explicit slide change gets a full, fresh interval — never a
    // leftover partial value from whatever was happening before
    remaining = interval;
    startTimer(interval);
    updatePausedClass();
  }

  var lightbox = root.querySelector('[data-spotlight-lightbox]');
  var lightboxMedia = root.querySelector('[data-spotlight-lightbox-media]');
  var lightboxCloseEls = Array.prototype.slice.call(root.querySelectorAll('[data-spotlight-lightbox-close]'));

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    if (lightboxMedia) lightboxMedia.innerHTML = '';
    resumeFrom('video');
    // restore the muted background preview on the active slide, if that setting is on
    if (videoAutoplay) playSlideMedia(slides[current]);
  }

  function openLightboxWithVideo(slide) {
    if (!lightbox || !lightboxMedia) return;

    var video = slide.querySelector('video');
    var iframe = slide.querySelector('iframe[data-embed-src]');

    lightboxMedia.innerHTML = '';

    if (video) {
      var source = video.querySelector('source');
      var src = source ? source.src : video.currentSrc;
      if (!src) return;
      var lightboxVideo = document.createElement('video');
      lightboxVideo.src = src;
      lightboxVideo.controls = true;
      lightboxVideo.autoplay = true;
      lightboxVideo.playsInline = true;
      lightboxVideo.className = 'ugc-spotlight__lightbox-video';
      lightboxMedia.appendChild(lightboxVideo);
    } else if (iframe) {
      var lightboxIframe = document.createElement('iframe');
      lightboxIframe.src = buildEmbedSrc(iframe, false);
      lightboxIframe.className = 'ugc-spotlight__lightbox-iframe';
      lightboxIframe.setAttribute('frameborder', '0');
      lightboxIframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      lightboxIframe.setAttribute('allowfullscreen', '');
      lightboxMedia.appendChild(lightboxIframe);
    } else {
      return;
    }

    // stop the inline background preview so it isn't playing under/behind the lightbox
    pauseSlideMedia(slide);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    pauseFor('video');
  }

  lightboxCloseEls.forEach(function (el) {
    el.addEventListener('click', closeLightbox);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) {
      closeLightbox();
    }
  });

  root.addEventListener('mouseenter', function () {
    pauseFor('hover');
  });
  root.addEventListener('mouseleave', function () {
    resumeFrom('hover');
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      goTo(current - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      goTo(current + 1);
    });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.getAttribute('data-index'), 10));
    });
  });

  slides.forEach(function (slide) {
    var playToggle = slide.querySelector('[data-spotlight-play-toggle]');
    if (playToggle) {
      playToggle.addEventListener('click', function () {
        openLightboxWithVideo(slide);
      });
    }
  });

  goTo(0);
}